import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const standcheckins = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 20,
            total: 0,
            page: 1,
            hasStandCheckIn: true,
            paymentStatus: null,
            paymentType: null,
            packetID: null,
            couponCode: null,
            standIDs: [],
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setStandCheckins(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.totalCount;
        },
        setSelectedStandCheckins(state, payload) {
            state.selectedItems = payload;
        },
        setStandCheckinPage(state, payload) {
            state.filter.page = payload;
            this.dispatch("getStandCheckin");
        },
        setStandCheckinTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch("getStandCheckin");
        },
    },
    actions: {
        async getStandCheckin(store) {
            store.state.loading = true;
            await axios
                .post("participant/list", {
                    ...store.state.filter,
                    skip: (store.state.filter.page - 1) * store.state.filter.take,
                })
                .then((res) => {
                    store.state.loading = false;
                    return store.commit("setStandCheckins", res.data.data);
                });
        },
        async toggleSpeaker(store, payload) {
            var res = await axios.post("speaker/toggleisactive", {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deleteStandCheckin(store, payload) {
            await axios
                .post("promotion/deletereceive", {
                    id: payload.id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit("setStandCheckinPage", store.state.filter.page - 1);
                        }
                        store.dispatch("getStandCheckin");
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
    },
    getters: {},
};
export default standcheckins;


// WEBPACK FOOTER //
// ./src/store/standcheckins.js